import { AllieText } from '../../../components';

export const AlliePageTitle: React.FC<{
  children: string;
  isMobile?: boolean;
  lineClamp?: number;
}> = ({ children, isMobile = false, lineClamp }) => (
  <div style={{ textAlign: 'left' }}>
    <AllieText
      type="h3"
      color="neutral-90"
      weight={500}
      style={{ wordBreak: 'break-word', fontSize: isMobile ? 18 : 20, lineHeight: '30px' }}
      lineClamp={lineClamp}
    >
      {children}
    </AllieText>
  </div>
);
